import React from 'react'
import "./Footer.css"
import { BsInstagram } from "react-icons/bs";
import { BsGithub } from "react-icons/bs";
import { BsLinkedin } from "react-icons/bs";
import { SiGmail } from "react-icons/si";

const Footer = () => {
  return (
    <div className='footer-section'>


<div className="rights">
<h6>{new Date().getFullYear()} &copy; All rights Reserved | Build by Iman.</h6>

</div>


<div className="socials">

<a
          className="icon"
          target="_blank"
          href="https://www.instagram.com/imann.av/"
        >
          <BsInstagram />
        </a>
        <a
          className="icon"
          target="_blank"
          href="https://github.com/Imann7"
        >
          <BsGithub />
        </a>
        <a
          className="icon"
          target="_blank"
          href="https://www.linkedin.com/in/iman-allahverdiyev/"
        >
          <BsLinkedin />
        </a>
        <a
          className="icon"
          target="_blank"
          href="mailto:imoallahverdiyev14@gmail.com"
        >
          <SiGmail />
        </a>


</div>



    </div>
  )
}

export default Footer